<div class="page-wrapper">
    <div class="page-main-header">
        <div class="main-header-right row">
            <div class="col-6 col-sm-7 col-lg-9 main-title">

               <div class="d-flex justify-content-between align-items-center">
    <!-- Sport name on left -->
                <h1 [class]="titleRed?'text-danger':''">{{ PageTitle }}</h1>

    <!-- Level in center -->
     <ng-container *ngIf="sportLevel">
          <h1 class="mb-0 text-center flex-grow-1">{{select_coach?.name}} {{ sportLevel?.sport }} ({{ sportLevel?.level }})</h1>

     </ng-container>
  </div>
            </div>
            <div class="col-6 col-sm-5 col-lg-3 main-right">
                <div class="acc-area d-flex justify-content-end align-items-center">
                    <div class="user-menu">
                        <div class="user-img">
                            <ng-container *ngIf="profile_image;else noImage">
                                <img [src]="profile_image" alt="" />
                            </ng-container>
                            <ng-template #noImage>
                                <img [src]="'assets/images/user.jpg'" alt="user image" />
                            </ng-template>
                            <span>Hi, {{ userDetails?.first_name }}!</span>
                        </div>
                    </div>
                    <div class="notify-menu">
                        <button mat-icon-button [matMenuTriggerFor]="notifymenu" (click)="fetchNotifications()">
                            <!-- <img src="assets/images/notification.png" alt="" /> -->
                            <mat-icon [matBadgeHidden]="(notificationCount == 0)?'true':'false'"
                                [matBadge]="notificationCount" matBadgeColor="warn">notifications</mat-icon>
                        </button>
                        <mat-menu #notifymenu="matMenu" xPosition="before" class="notify-drop">
                            <div class="notify-list" style="width: 250px;">
                                <span *ngIf="!apiCalled" class="d-flex justify-content-center align-items-center"
                                    style="height: 100px;">
                                    <mat-spinner [diameter]="30"></mat-spinner>
                                </span>
                                <ul>
                                    <li *ngFor="let notification of notifications">
                                        <div class="app-list">
                                            <!-- <img src="assets/images/user.jpg" alt="" /> -->
                                            <div class="noti-des w-100">
                                                <h4>{{notification.notification_message}}</h4>
                                                <span class="d-block"
                                                    style="font-size: 10px; text-align: right; color: grey;">{{notification.created_at
                                                    | date:'medium'}}</span>
                                            </div>
                                        </div>
                                    </li>
                                    <!-- <li>
                                        <div class="app-list">
                                            <img src="assets/images/user.jpg" alt="" />
                                            <div class="noti-des">
                                                <h4>What is Lorem Ipsum?</h4>
                                                <p>8 days ago</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="app-list">
                                            <img src="assets/images/user.jpg" alt="" />
                                            <div class="noti-des">
                                                <h4>What is Lorem Ipsum?</h4>
                                                <p>10 days ago</p>
                                            </div>
                                        </div>
                                    </li> -->
                                    <li class="showall" *ngIf="!notifications.length && apiCalled">
                                        No Notification
                                    </li>
                                    <li class="showall" *ngIf="notifications.length && apiCalled">
                                        <a style="cursor: pointer;" (click)="navigateToNotification()">See All</a>
                                    </li>
                                </ul>
                            </div>
                        </mat-menu>
                    </div>
                    <div class="mob-menu">
                        <button (click)="toggleMobMenu()">
                            <mat-icon>reorder</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="page-body-wrapper">
        <div class="page-sidebar" [ngClass]="{'showMenu': mobMenu === true}">
            <div class="main-header-left">
                <div class="logo-wrapper">
                    <a href="javascript:void(0)"><img src="assets/images/logo.svg" alt="" /></a>
                </div>
            </div>
            <div class="sidebar custom-scrollbar">
                <app-sidebar-nav></app-sidebar-nav>
            </div>
        </div>

        <div class="page-body">
            <div class="body-wrapper">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
